"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloudinaryCroppedPhotoUrl = exports.cloudinaryGrayscalePhotoUrl = void 0;
var cloudinaryGrayscalePhotoUrl = function (url) {
  var matches = url.match(/(https\:\/\/res.cloudinary.com\/[^\/]+\/image\/upload\/)(.+$)/i);
  if (matches.length >= 3) {
    return "".concat(matches[1], "e_grayscale,c_thumb,w_400,h_400,dpr_2,f_auto,g_face,q_auto:good/").concat(matches[2]);
  }
  return url;
};
exports.cloudinaryGrayscalePhotoUrl = cloudinaryGrayscalePhotoUrl;
var cloudinaryCroppedPhotoUrl = function (url) {
  var matches = url.match(/(https\:\/\/res.cloudinary.com\/[^\/]+\/image\/upload\/)(.+$)/i);
  if (matches.length >= 3) {
    return "".concat(matches[1], "c_thumb,w_400,h_400,dpr_2,f_auto,g_face,q_auto:good/").concat(matches[2]);
  }
  return url;
};
exports.cloudinaryCroppedPhotoUrl = cloudinaryCroppedPhotoUrl;